import {
  createRouter,
  createWebHistory,
  RouteRecordRaw,
  RouteLocationNormalized
} from 'vue-router'

import MctView from '../MctView.vue'

import oauth from '@/utils/oauth'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'MctView',
    redirect: '/customized-view',
    component: MctView,
    meta: { hasAccess: true, privilege: 0 },
    children: [
      // {
      //   path: '/one-view',
      //   name: 'One View',
      //   meta: { title: 'One View' },
      //   component: () =>
      //     import(
      //       /* webpackChunkName: 'OneView' */ '../views/home/one-view/index.vue'
      //     )
      // },
      {
        path: '/cluster-view',
        name: 'Cluster View',
        meta: { title: 'Cluster View', privilege: 0 },
        component: () =>
          import(
            /* webpackChunkName: 'ClusterView' */ '../views/home/cluster-view/index.vue'
          )
      },
      {
        path: '/customized-view/:id?',
        name: 'Customized View',
        meta: {
          title: 'Customized View',
          privilege: 0,
          parentSideItem: '/customized-view'
        },
        component: () =>
          import(
            /* webpackChunkName: 'CustomizedView' */ '../views/home/customized-view/index.vue'
          )
      },
      {
        path: '/mct-service-view',
        name: 'MCT Service View',
        meta: { title: 'MCT Service View', privilege: 0 },
        component: () =>
          import(
            /* webpackChunkName: 'MCTServiceView' */ '../views/home/mct-service-view/index.vue'
          )
      },
      {
        path: '/service-view',
        name: 'Service View',
        meta: { title: 'Service View', privilege: 100 },
        component: () =>
          import(
            /* webpackChunkName: 'ServiceView' */ '../views/home/service-view/index.vue'
          )
      },
      {
        path: '/infrastructure/:id?',
        name: 'Infrastructure',
        meta: {
          title: 'Infrastructure',
          privilege: 100,
          parentSideItem: '/infrastructure'
        },
        component: () =>
          import(
            /* webpackChunkName: 'Infrastructure' */ '../views/management/infrastructure/index.vue'
          )
      },
      // {
      //   path: '/batch-operation',
      //   name: 'Batch Operation',
      //   meta: { title: 'Batch Operation' },
      //   component: () =>
      //     import(
      //       /* webpackChunkName: 'Batch Operation' */ '../views/management/batch-operation/index.vue'
      //     )
      // },
      {
        path: '/data-center',
        name: 'Data Center',
        meta: { title: 'Data Center', privilege: 100 },
        component: () =>
          import(
            /* webpackChunkName: 'Data Center' */ '../views/management/data-center/index.vue'
          )
      },
      {
        path: '/svrtype-setting',
        name: 'SvrType Settings',
        meta: { title: 'SvrType Settings', privilege: 255 },
        component: () =>
          import(
            /* webpackChunkName: 'SvrType Settings' */ '../views/management/svrtype-setting/index.vue'
          )
      },
      {
        path: '/url-template',
        name: 'URL Template',
        meta: { title: 'URL Template', privilege: 100 },
        component: () =>
          import(
            /* webpackChunkName: 'URL Template' */ '../views/management/url-template/index.vue'
          )
      },
      {
        path: '/mct-service-settings',
        name: 'MCT Service Settings',
        meta: { title: 'MCT Service Settings', privilege: 100 },
        component: () =>
          import(
            /* webpackChunkName: 'MCT Service Settings' */ '../views/management/mct-service-settings/index.vue'
          )
      },
      {
        path: '/customized-settings',
        name: 'Customized Settings',
        meta: { title: 'Customized Settings', privilege: 100 },
        component: () =>
          import(
            /* webpackChunkName: 'Customized Settings' */ '../views/management/customized-settings/index.vue'
          )
      },
      {
        path: '/import-export-cluster',
        name: 'Import/Export Cluster',
        meta: { title: 'Import/Export Cluster', privilege: 100 },
        component: () =>
          import(
            /* webpackChunkName: 'Import/Export Cluster' */ '../views/management/import-export-cluster/index.vue'
          )
      },
      {
        path: '/appium-test-case',
        name: 'Appium Test Case',
        meta: { title: 'Appium Test Case', privilege: 0 },
        component: () =>
          import(
            /* webpackChunkName: 'Appium Test Case' */ '../views/management/appium-test-case/index.vue'
          )
      },
      {
        path: '/appium-test-account',
        redirect: '/appium-resources/account'
      },
      {
        path: '/appium-resources',
        name: 'Appium Resources',
        meta: { title: 'Appium Resources', privilege: 0 },
        redirect: '/appium-resources/account',
        component: () =>
          import(
            /* webpackChunkName: 'Appium Resources' */ '../views/management/appium-resources/index.vue'
          ),
        children: [
          {
            path: 'account',
            name: 'AppiumTestAccount',
            component: () =>
              import(
                '../views/management/appium-resources/test-account/index.vue'
              ),
            meta: { title: 'Appium Test Account' }
          },
          {
            path: 'machine',
            name: 'AppiumWinMachine',
            component: () =>
              import(
                '../views/management/appium-resources/win-machine/index.vue'
              ),
            meta: { title: 'Appium Machine' }
          },
          {
            path: 'upgrade',
            name: 'AppiumUpgradeInfo',
            component: () =>
              import(
                '../views/management/appium-resources/upgrade-info/index.vue'
              ),
            meta: { title: 'Appium Upgrade Info' }
          }
        ]
      },
      {
        path: '/alert-rules/:ruleId?',
        name: 'Alert Rules',
        meta: { title: 'Alert Rules', privilege: 0 },
        component: () =>
          import(
            /* webpackChunkName: 'Alert Rules' */ '../views/management/alert-rules/index.vue'
          )
      },
      {
        path: '/cluster-status/:id?',
        name: 'Cluster Status',
        meta: { title: 'Cluster Status', privilege: 0 },
        component: () =>
          import(
            /* webpackChunkName: 'Cluster Status' */ '../views/status/ClusterStatus.vue'
          )
      },
      // {
      //   path: '/zone-status/:id',
      //   name: 'Zone Status',
      //   meta: { title: 'Zone Status' },
      //   component: () =>
      //     import(
      //       /* webpackChunkName: 'Zone Status' */ '../views/status/ZoneStatus.vue'
      //     )
      // },
      {
        path: '/detail-status/:id?',
        name: 'Detail Status',
        meta: { title: 'Detail Status', privilege: 0 },
        component: () =>
          import(
            /* webpackChunkName: 'Detail Status' */ '../views/status/DetailStatus.vue'
          )
      },
      {
        path: '/cloud-agent-dispatch',
        name: 'Cloud Agent Dispatch',
        meta: { title: 'Cloud Agent Dispatch', privilege: 255 },
        component: () =>
          import(
            /* webpackChunkName: 'Cloud Agent Dispatch' */ '../views/agents/cloud-agent-dispatch/index.vue'
          )
      },
      {
        path: '/cloud-agent-manage/:id?',
        name: 'Cloud Agent Manage',
        meta: {
          title: 'Cloud Agent Manage',
          privilege: 255,
          parentSideItem: '/cloud-agent-manage'
        },
        component: () =>
          import(
            /* webpackChunkName: 'Cloud Agent Manage' */ '../views/agents/cloud-agent-manage/index.vue'
          )
      },
      // Admin
      {
        path: '/activity-log',
        name: 'Activity Log',
        meta: { title: 'Activity Log', privilege: 255 },
        component: () =>
          import(
            /* webpackChunkName: 'Activity Log' */ '../views/admin/activity-log/index.vue'
          )
      },
      {
        path: '/user-list',
        name: 'User List',
        meta: { title: 'User List', privilege: 100 },
        component: () =>
          import(
            /* webpackChunkName: 'User List' */ '../views/admin/user-list/index.vue'
          )
      },
      {
        path: '/plugin-list',
        name: 'Plugin List',
        meta: { title: 'Plugin List', privilege: 255 },
        component: () =>
          import(
            /* webpackChunkName: 'Plugin List' */ '../views/admin/plugin-list/index.vue'
          )
      },
      {
        path: '/failover-mct',
        name: 'Failover MCT',
        meta: { title: 'Failover MCT', privilege: 255 },
        component: () =>
          import(
            /* webpackChunkName: 'Failover MCT' */ '../views/admin/failover-mct/index.vue'
          )
      }
    ]
  },
  {
    path: '/ciLogin',
    name: 'ciLogin',
    component: () =>
      import(/* webpackChunkName: 'oauth' */ '../views/OauthView.vue'),
    meta: { hasAccess: true, privilege: 0 }
  },
  {
    path: '/logout',
    name: 'logout',
    component: () =>
      import(/* webpackChunkName: 'logout' */ '../views/LogoutView.vue'),
    meta: { hasAccess: true, privilege: 0 }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to: RouteLocationNormalized, from, next) => {
  if (to.name === 'ciLogin' || to.name === 'logout') {
    next()
    return
  }
  if (!oauth.isAuthorized()) {
    await oauth.redirectForAuthCode(to)
  } else {
    next()
  }

  if (to.meta.title) {
    // @ts-ignore
    document.title = to.meta.title
  }
})

router.beforeResolve(async (to: any) => {
  const userInfo = JSON.parse(localStorage.getItem('MCT_USER_INFO') as string)
  const userPrivilege = userInfo?.privilege
  if (userPrivilege < (to.meta.privilege as number)) {
    return '/'
  }
  if (!to.meta.hasAccess) {
    return false
  }
})

export default router
